// Shared helpers for rendering a user's floor plan "get to know me" details,
// used by both the seat details dialog and the unit remote-users dialog.

const FIELD_LABELS = {
    start_date: 'Start Date',
    from_location: 'From',
    unit: 'Unit',
    title: 'Title',
    company_email: 'Company Email',
    what_i_actually_do: 'What They Actually Do',
    hobbies: 'Hobbies',
    ask_me_about: 'Ask Me About',
    fun_fact: 'Fun Fact',
};

export function firstName(user) {
    if (!user) return '';
    return user.first_name || (user.name || '').split(' ')[0];
}

export function detailFields(details, keys) {
    if (!details) return [];
    const fieldKeys = keys || Object.keys(FIELD_LABELS);
    return fieldKeys
        .filter((key) => details[key])
        .map((key) => ({ key, label: FIELD_LABELS[key], value: details[key] }));
}
